window.dtOperator = function () {
  const dt_operator = new DataTable('#operator-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#operator-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#operator-datatable', 4); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[3, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "code" },
      { "data": "name" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}
